/**
 * Urban Element Colors — default color per mappable element type
 *
 * @module core/modules/urban/constants/element-colors
 *
 * @description
 * Colores por defecto para los 6 tipos de elementos del módulo urbano
 * que se representan en el mapa. El usuario puede personalizar cada color
 * desde el panel.
 */

/** The 6 urban element types that have map representation */
export type UrbanElementId =
  | 'parcels'
  | 'buildings'
  | 'zoning'
  | 'land-use'
  | 'regulations'
  | 'projects';

export const URBAN_ELEMENT_COLORS: Record<UrbanElementId, string> = {
  'parcels':     '#8b5cf6', // violeta (parcelas)
  'buildings':   '#6366f1', // índigo (edificios)
  'zoning':      '#06b6d4', // cyan (zonificación)
  'land-use':    '#10b981', // verde (usos de suelo)
  'regulations': '#f59e0b', // ámbar (normativa)
  'projects':    '#ec4899', // rosa (proyectos)
};

/** Set of IDs for quick lookup */
export const MAPPABLE_ELEMENT_IDS = new Set<string>(
  Object.keys(URBAN_ELEMENT_COLORS),
);
